'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
'use client';
export let Store=undefined
export let ReactScanInternals=undefined
export let getReport=()=>{console.error('Do not use getReport directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let setOptions=()=>{console.error('Do not use setOptions directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let getOptions=()=>{console.error('Do not use getOptions directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let getIsProduction=()=>{console.error('Do not use getIsProduction directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let start=()=>{console.error('Do not use start directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let scan=()=>{console.error('Do not use scan directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let useScan=()=>{console.error('Do not use useScan directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let onRender=()=>{console.error('Do not use onRender directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let ignoredProps=()=>{console.error('Do not use ignoredProps directly in a Server Component module. It should only be used in a Client Component.');return undefined}
export let ignoreScan=()=>{console.error('Do not use ignoreScan directly in a Server Component module. It should only be used in a Client Component.');return undefined}
